import React, { createContext, useState, useContext } from "react";
import { User } from "../models";

// 1. Create the context

interface AuthContextType {
  user: User | null;
  ready: boolean;
  loaded: (value: boolean) => void;
  login: (user: User) => void;
  logout: () => void;
  // ...other fields
}
export const AuthContext = createContext<AuthContextType>({
  user: null,
  ready: false,
  loaded: (value: boolean) => {
    console.warn("login function not implemented");
  },

  login: () => {
    console.warn("login function not implemented");
  },
  logout: () => {
    console.warn("logout function not implemented");
  },
});

// 2. Create the Provider component
export const AuthProvider = ({ children }: any) => {
  const [user, setUser] = useState<User>(); // state to hold user data
  const [ready, setReady] = useState(false);
  // 'login' function to be called after API success
  const login = (userData: User) => {
    const staticUrl = process.env.REACT_APP_AWS_URL;
    if(userData.profileImage && userData.profileImage.startsWith("profile-images"))
      userData.profileImage = `${staticUrl}/${userData.profileImage}`;
    setUser(userData);
    loaded(true);
  };

  // 'logout' function
  const logout = () => {
    setUser(undefined);
    loaded(true);
    // You'd also call an API endpoint here to invalidate the server-side session/cookie
  };
  const loaded = (value: boolean) => {
    setReady(value);
  };
  const value: any = { user, ready, login, logout, loaded };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

// 3. Create a custom hook for easy access
export const useAuth = () => {
  return useContext(AuthContext);
};
